var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-editor"},[_c('ckeditor',{attrs:{"editor":_vm.editor,"value":_vm.value},on:{"input":function (value) { return _vm.$emit('input',value); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }